<template>
  <b-container class="bv-example-row background" fluid>
    <div class="row" style="min-height:20vh">
        <div v-show="$mainDomain == 'Wynum'" class="offset-md-1 col-md-7 mainheader" style="margin-top:10vh;font-size:6vh;font-family:inherit">
            {{$mainDomain}}
        </div>
        <div v-show="$mainDomain != 'Wynum'" class="offset-md-1 mainheader" style="margin-top:8vh;font-size:6vh;font-family:inherit">
            <img :src="getImgUrl()" style="height:18vh;width:18vw">
        </div>
    </div>
    <div class="row" style="min-height:20vh">
        <div class="offset-md-1 col-md-7 mainheader" style="margin-top:5vh;font-family:'Avenir', Helvetica, Arial, sans-serif">
            <!--Disappearing uncertainty is a sight to behold-->
            Solve the problem before you see it
        </div>
        <div class="offset-md-1 col-md-7 mainsubheader" style="margin-top:4vh">
          Reset Password
        </div>
    </div>
    <div v-if="!showconfirm && !showresetpass" class="row" style="min-height:15vh;margin-top:1vh;margin-bottom:3vh;">
        <div class="offset-md-1 col-md-10">
            <div class="form-group" style="text-align:left;color:white">
              Enter Your Email Address  
            </div>
        </div>
        <div class="offset-md-1 col-md-4">
            <div class="form-group" style="text-align:left;">
                <input v-model="userid" type="text" class="form-control form-label-group" name="userid" id="exampleInputPassword1" placeholder="Email" v-on:keyup="onEnterEmail($event)">
            </div>
        </div>
        <div class="col-md-7">
            <div class="form-group" style="text-align:left;">
                <button :class="{ disabled: isDisabled }" :disabled="isDisabled" @click="passwordconfirm()" class="btn home-orange-btn" style="cursor:pointer">Next</button>
            </div>
        </div>
    </div>
    <div v-if="showconfirm && !showresetpass" class="row" style="min-height:15vh;margin-top:1vh;margin-bottom:3vh;">
        <div class="offset-md-1 col-md-10">
            <div class="form-group" style="text-align:left;color:white">
              Enter Confirmation Code
            </div>
        </div>
        <div class="offset-md-1 col-md-4">
            <div class="form-group" style="text-align:left;">
                <input v-model="code" type="text" class="form-control form-label-group" name="code" id="exampleInputPassword1" placeholder="Code" v-on:keyup="onEnterCode($event)">
            </div>
        </div>
        <div class="col-md-7">
            <div class="form-group" style="text-align:left;">
                <button :class="{ disabled: iscodeDisabled }" :disabled="iscodeDisabled" @click="confirm()" class="btn home-orange-btn" style="cursor:pointer">Confirm</button>
            </div>
        </div>
    </div>
    <div v-if="showresetpass" class="row" style="min-height:15vh;margin-top:2vh;">
        <div class="offset-md-1 col-md-4">
            <div class="form-group" style="text-align:left;">
                <input v-model="password" type="password" class="form-control form-label-group" name="username" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Password">
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group" style="text-align:left;">
                <input v-model="password1" type="password" class="form-control form-label-group" name="password1" id="exampleInputPassword1" placeholder="Confirm Password">
            </div>
        </div>
        <div class="col-md-2">
            <div class="form-group" style="text-align:left;">
                <button @click="resetpass()" class="btn home-orange-btn" style="cursor:pointer">Reset</button>
            </div>
        </div>
    </div>
    <div class="row" style="min-height:20vh;text-align:left">
        <div class="offset-md-1 col-md-11">
            <div class="row" style="color:white">
                <div class="col-md-2">
                    <div class="sub1">Already User?</div>
                    <hr style="border-top: 2px solid #fff;">
                    <div class="sub2"><a class="link" @click="loginpage()"><b>Sign In Now  ►</b></a></div>
                </div>
                <!--<div class="col-md-2">
                    <div class="sub1">New User?</div>
                    <hr style="border-top: 2px solid #fff;">
                    <div class="sub2"><a class="link" @click="registerpage()"><b>Register Now  ►</b></a></div>
                </div>
                <div class="col-md-3">
                    <div class="sub1">Resend confirmation code</div>
                    <hr style="border-top: 2px solid #fff;">
                    <div class="sub2"><a class="link" @click="confirmpage()"><b>Generate Now  ►</b></a></div>
                </div>-->
            </div>
            <div class="row" style="color:white;margin-top:5vh;">
                <div class="col-md-12" style="text-align:left">{{$mainDomain}}<br>@2020, All rights reserved.</div>
            </div>
        </div>
    </div>
    <div class="row" style="min-height:5vh">
        <div class="bottom_image"></div>
    </div>
  </b-container>
</template>

<script>
//require('@/assets/css/login.css')
import axios from 'axios'
import { EventBus } from '../event-bus.js'

export default {
  name: 'Login',
  data () {
    return {
      userid: '',
      error: false,
      codeerror : false,
      password: '',
      auth_token: '',
      message: '',
      title: '',
      showconfirm : '',
      code:'',
      codemessage:'',
      showresetpass : false,
      password1:'',
      passwordmessage:false,
      pwd:false,

    }
  },
  created (){
  },
  computed: {
    isDisabled () {
      if (this.userid !== '') {
        return false
      } else {
        return true
      }
    },
    iscodeDisabled () {
      if (this.code !== '' && this.code !== '') {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    getImgUrl() {
      var images = require.context('../assets/', false, /\.png$/)
      return images('./' + this.$mainDomain + ".png")
    },
    passwordconfirm () {
      this.error = false
      this.codeerror = false
      axios.post('/forgotpasswordapi?username=' + this.userid)
        .then(res => {
          if (res.data.value !== null && res.data.value !== 1) {
            this.showconfirm = true
            this.message = res.data.message
            this.ShowToast("Success", 'Confirmation code has been sent successfully.', "default")
          } else {
            this.error = true
            this.message = res.data.error
            this.ShowToast("Error", res.data.error, "default")
          }
        })
    },
    confirm () {
      this.error = false
      this.codeerror = false
      axios.post('/passwordresetcodeapi?code=' + this.code)
        .then(res => {
          if (res.data.value !== null && res.data.value !== 1) {
            this.auth_token = res.data.token
            this.showresetpass = true
            this.ShowToast("Success", 'Code has been confirmed successfully. Please reset your password.', "default")
          } else {
            this.codeerror = true
            this.codemessage = res.data.error
            this.ShowToast("Error", res.data.error, "default")
          }
        })
    },
    resetpass(){
      if(this.password)
        if(this.password.length >= 8){
          if(this.password != this.password1){
          this.ShowToast("Error",  "Passwords don't match", "default")
          return
        }
      }else{
        this.ShowToast("Error",  "Password should be atleast 8 characters long.", "default")
        return
      }

      this.error = false
      this.codeerror = false
      axios.post('/resetpassword?password=' + this.password+"&token="+this.auth_token)
        .then(res => {
          if (res.data.value !== null && res.data.value !== 1) {
            localStorage.setItem('authtoken', this.auth_token)
            axios.defaults.headers.common['Authorization'] = this.auth_token
            EventBus.$emit('login', this.auth_token)
            this.$router.push('/ChatDesign')
          } else {
            this.pwd = true
            this.passwordmessage = "Error while resetting password. Please try later."
            this.ShowToast("Error",  "Error while resetting password. Please try later.", "default")
          }
        })
    },
    ShowToast(header, body, color){
      this.$bvToast.toast(body, {
      title: header,
      variant: color,
      solid: true,
      toaster: 'b-toaster-bottom-center'
      })
    },
    onEnterEmail(e){
      if (e.keyCode === 13) {
        this.passwordconfirm()
      }
    },
    onEnterCode(e){
      if (e.keyCode === 13) {
        this.confirm()
      }
    },
    confirmpage(){
      this.$router.push("/Confirm")
    },
    loginpage(){
      this.$router.push('/')
    },
    registerpage () {
     this.$router.push('/Register')
    },
  }
}
</script>

<style scoped>
    @font-face {
        font-family: Lato;
        src: url('//fonts.googleapis.com/css?family=Lato');
    }
.mainbox {
    height: auto;
    background-image: linear-gradient(136deg, #86c6fa, #596cd5, #496cae, #1c4491);
  }
  .loginbox {
    background-color: #f5f6fb
  }
  .btn-login-google {
      border-radius: 25px;
      border: solid 2px white;
      background-color: white;
      color:#0393f6;
      font-size: large;
      width: 100%;
      height: 50px;
      font-size:larger;
      display: initial;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
  }
  .btn-login {
      border-radius: 25px;
      border: solid 2px #0393f6;
      background-color: #0393f6;
      color:white;
      width: 147px;
      height: 50px;
      font-size:larger;
      display: initial
  }
  
  .btn-header{
      border-radius: 25px;
      border: solid 2px #4427d7;
      background-color: #4427d7;
      color:white;
      height: 50px;
      font-size:larger;
  }
  
  .btn-toggle{
      border-radius: 20.5px;
      background-color: #4427d7;
  }
  
  .list-inline-item:not(:last-child) {
      margin-right: 1rem;
  }
  
  .card-title{
      font-size: 1.7vw;
      text-align: left;
  }
  
  .card-body{
      text-align: center;
  }
  
  .card-text{
      text-align: left;
      font-size: 1.1vw;
  }
    
  .form-label-group {
      position: relative;
      margin-bottom: 1rem;
      border-radius: 10px;
      padding: 3vh;
      font-size: 1vw;
  }
    
  .form-label-group>input,
    .form-label-group>label {
      padding: 20px;
      height: auto;
      border-radius: 10px;
  }
    
  .form-label-group>label {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 100%;
      margin-bottom: 0;
      /* Override default `<label>` margin */
      line-height: 1.5;
      color: #495057;
      cursor: text;
      /* Match the input under the label */
      border: 1px solid transparent;
      border-radius: .25rem;
      transition: all .1s ease-in-out;
  }
    
  .form-label-group input::-webkit-input-placeholder {
      color: transparent;
  }
    
  .form-label-group input:-ms-input-placeholder {
      color: transparent;
  }
    
  .form-label-group input::-ms-input-placeholder {
      color: transparent;
  }
    
  .form-label-group input::-moz-placeholder {
      color: transparent;
  }
  
  .form-label-group input::placeholder {
      color: transparent;
  }
    
  .form-label-group input:not(:placeholder-shown) {
      padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
      padding-bottom: calc(var(--input-padding-y) / 3);
  }
    
  .form-label-group input:not(:placeholder-shown)~label {
      padding-top: calc(var(--input-padding-y) / 3);
      padding-bottom: calc(var(--input-padding-y) / 3);
      font-size: 12px;
      color: #777;
  }
  
  .register .nav-tabs{
      width: 16vw;
      height: 2.5vw;
      background-color: #e7e8f0;
      border-radius: 1.5rem;
      float: right;
  }
  .register .nav-tabs .nav-link{
      font-size: 1vw;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: center;
      color: #596cd5;
  }
  .register .nav-tabs .nav-link:hover{
      border: none;
  }
  .register .nav-tabs .nav-link.active{
      width: 9vw;
      height: 2.5vw;
      object-fit: contain;
      border-radius: 20.5px;
      background-color: #596cd5;
      border: solid 2px #596cd5;
      color: #ffffff
  }
  .register-heading{
      text-align: center;
      margin-top: 8%;
      margin-bottom: -15%;
      color: #495057;
  }
  
  .register-main-text {
      text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.34);
      font-size: 2.9vw;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.36;
      letter-spacing: normal;
      text-align: left;
      color: #ffffff;
  }
  
  .register_sub_text {
      font-size: 1.2vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.62;
        letter-spacing: normal;
        text-align: left;
        color: #ffffff;
  }
  .home-orange-btn{
    background-color: #f16621 !important;
    color: white !important;
    text-transform: uppercase !important;
    border-radius: 5px !important;
    padding: 1.3vh 4vh !important;
    font-size: 2vh !important;
    font-weight: 500 !important;
    text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.34) !important;
    line-height: 1.5 !important;
  }
  
  footer {
    position: fixed;
    bottom:0;
  }
    .background{
        background-image: url("../assets/background1.png");
        object-fit: cover;
        background-repeat: no-repeat;
        background-size: 100%;
        min-height: 100vh;
    }
    .bottom_image{
        background-image: url("../assets/bottom.png");
        height: 2vh;
        width: 100vw;
        position: fixed;
        bottom: 0;
    }
    .mainheader{
        font-family: Lato;
        font-size: 9.5vh;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.96;
        letter-spacing: normal;
        text-align: left;
        color: #ffffff;
    }
    .mainsubheader{
        font-family: Lato !important;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.65;
        letter-spacing: 1px;
        text-align: left;
        color: #ffffff;
        text-transform: uppercase;
        margin-top:2vh;
    }
    .link{
        cursor: pointer;
    }
</style>

